module.exports = __webpack_public_path__ + "static/media/39.5f0a55a7.jpg";